export type FilterCategories = keyof typeof filterCategories;

export const filterCategories = {
  educationLevels: 'educationLevels',
  functions: 'functions',
  jobTypes: 'jobTypes',
  workingAreas: 'workingAreas',
  cities: 'cities',
  hours: 'hours',
  isCoolblueEnergy: 'isCoolblueEnergy'
} as const;

export const collapsableFilterCategories: FilterCategories[] = Object.values(
  filterCategories
).filter(option => option !== filterCategories.functions);
